import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from 'react-schemaorg';


const getDrawImage = (drawtype, typeid) => {
    switch (drawtype) {
        // case 'vs5luckyphnly': return 'https://gt.starteams.in/cdn/assets/slots/Lucky_Phoenix.png';
        // case 'vs15eyeofspart': return 'https://gt.starteams.in/cdn/assets/slots/Eye_of_Spartacus.png';
        // case 'vswaysmwss': return 'https://gt.starteams.in/cdn/assets/slots/Mahjong_Wins_Super_Scatter.png';
        // case 'vs5luckyt1kly': return 'https://gt.starteams.in/cdn/assets/slots/Lucky_Tiger_1000.png';
        // case 'vs20gtsofhades': return "https://gt.starteams.in/cdn/assets/slots/Gates_of_Hades.png";
        // case 'vswaysmjwl': return "https://gt.starteams.in/cdn/assets/slots/Mummy's_Jewels.png";
        // case 'vs20jjjack': return "https://gt.starteams.in/cdn/assets/slots/Jumbo_Safari.png"
        // case 'vs10gbseries': return "https://gt.starteams.in/cdn/assets/slots/Fiesta_Fortune.png"
        // case 'vs5luckymly': return "https://gt.starteams.in/cdn/assets/slots/Lucky_Monkey.png"
        // case 'vs25sleepdrag': return "https://gt.starteams.in/cdn/assets/slots/Sleeping_Dragon.png"
        // case 'vs25sleepdrag': return "https://gulfticket.starteams.in/cdn/assets/slots/MagicAquarium20_v1.png"
        // case '153': return "http://220.225.104.136/cdn/GulfTicket/assets/slots/MagicAquarium20_v1.png"
        // case '161': return "http://220.225.104.136/cdn/GulfTicket/assets/slots/FortunePirates40_v1.png"
        // case '164': return "http://220.225.104.136/cdn/GulfTicket/assets/slots/WildDraw50_v1.png"
        // case '164': return "http://220.225.104.136/cdn/GulfTicket/assets/slots/WildDraw50_v1.png"
        // case "145": return "https://thetechstage.com/cdn/assets/slots/FruitsCarnival_v1.png"
        // case "151": return "https://thetechstage.com/cdn/assets/slots/GoldenQueen50_v1.png"
        // case "141": return "https://thetechstage.com/cdn/assets/slots/LuckyLantern_v1.png"
        // case "108": return "https://thetechstage.com/cdn/assets/slots/ZodiacKingdom10_v1.png"
        // case "148": return "https://thetechstage.com/cdn/assets/slots/MagicBasket_v1.png"
        // case "128": return "https://thetechstage.com/cdn/assets/slots/AfricanDiamond100_v1.png"
        // case "138": return "https://thetechstage.com/cdn/assets/slots/MysteryArk_v1.png"
        // case 'vswayswildbrst': return "https://thetechstage.com/cdn/web/assets/slotsex/Witch_Heart_Megaways.png"
        // case 'vswaysresurich': return "https://thetechstage.com/cdn/web/assets/slotsex/Resurrecting_Riches.png"
        // case 'vs5jellyc': return "https://thetechstage.com/cdn/web/assets/slotsex/Jelly_Candy.png"
        // case 'vs20olympgold': return "https://thetechstage.com/cdn/web/assets/slotsex/Gates_of_Olympus_Super_Scatter.png"
        // case 'vs20fatbook': return "https://thetechstage.com/cdn/web/assets/slotsex/Book_of_Monsters.png"
        // case 'vs5jokerjc': return "https://thetechstage.com/cdn/web/assets/slotsex/Joker's_Jewels_Cash.png"
        // case 'vs9ridelightng': return "https://thetechstage.com/cdn/web/assets/slotsex/Ride_The_Lightning.png"
        // case 'vswaysmodfr': return "https://thetechstage.com/cdn/web/assets/slotsex/Ancient_Island_Megaways.png"
        // case 'vs10fireice': return "https://thetechstage.com/cdn/web/assets/slotsex/Escape_the_Pyramid_Fire_Ice.png"
        // case 'vswaysaztec': return "https://thetechstage.com/cdn/web/assets/slotsex/Aztec_Gems_Megaways.png"



    }
};

const getDrawTitle = (drawtype, typeid) => {
    switch (drawtype) {
        case 'vs5luckyphnly': return 'Lucky Phoenix Online Slot – Spin & Win';
        case 'vs15eyeofspart': return 'Play Eye of Spartacus Slot | Free Spins & Big Wins';
        case 'vswaysmwss': return 'Mahjong Wins Super Scatter Slot – High RTP & Hot Bonuses';
        case 'vs5luckyt1kly': return 'Lucky Tiger 1000 – Online Slot Game | Play Now';
        case 'vs20gtsofhades': return 'Gates of Hades Slot Machine – Wild Reels & Jackpots';
        case 'vswaysmjwl': return "Mummy's Jewels Online Slot – Spin & Win";
        case 'vs20jjjack': return "Play Jumbo Safari Slot | Free Spins & Big Wins";
        case 'vs10gbseries': return "Fiesta Fortune Slot – High RTP & Hot Bonuses";
        case 'vs5luckymly': return "Lucky Monkey – Online Slot Game | Play Now";
        case 'vs25sleepdrag': return "Sleeping Dragon Slot Machine – Wild Reels & Jackpots";
        case '153': return "MAGIC AQUARIUM Online Slot – Spin & Win"
        case '161': return "Play FORTUNE PIRATES Slot | Free Spins & Big Wins"
        case '164': return "WILD DRAW Slot – High RTP & Hot Bonuses"
        case "145": return "FRUITS CARNIVAL – Online Slot Game | Play Now"
        case "151": return "GOLDEN QUEEN Slot Machine – Wild Reels & Jackpots"
        case "141": return "LUCKY LATERN Online Slot – Spin & Win"
        case "108": return "Play ZODIAC KINGDOM Slot | Free Spins & Big Wins"
        case "148": return "MAGIC BASKET Slot – High RTP & Hot Bonuses"
        case "128": return "AFRICAN DIAMOND – Online Slot Game | Play Now"
        case "138": return "MYSTERY ARK Slot Machine – Wild Reels & Jackpots"
        case 'vswayswildbrst': return "Witch Heart Megaways Online Slot – Spin & Win"
        case 'vswaysresurich': return "Play Resurrecting Riches Slot | Free Spins & Big Wins"
        case 'vs5jellyc': return "Jelly Candy Slot – High RTP & Hot Bonuses"
        case 'vs20olympgold': return "Gates of Olympus Super Scatter – Online Slot Game | Play Now"
        case 'vs20fatbook': return "Book of Monsters Slot Machine – Wild Reels & Jackpots"
        case 'vs5jokerjc': return "Joker's Jewels Cash Online Slot – Spin & Win"
        case 'vs9ridelightng': return "Play Ride The Lightning Slot | Free Spins & Big Wins"
        case 'vswaysmodfr': return "Ancient Island Megaways Slot – High RTP & Hot Bonuses"
        case 'vs10fireice': return "Escape the Pyramid - Fire & Ice – Online Slot Game | Play"
        case 'vswaysaztec': return "Aztec Gems Megaways Slot Machine – Wild Reels & Jackpots"

        case '1': return "Golden Match Scratch Card – Instant Wins Online"
        case '2': return "Treasure Ticket – Match & Win | Scratch Card Game"
        case '3': return "Play Lucky 1 Scratch Card | Quick Prizes"
        case '4': return "Super Scratch 10 – Top Scratch Card for Fast Wins"
        case '5': return "Dream Match Online Scratch Card – Try Your Luck"
        case '6': return "Christmas/Santa Scratch Card – Instant Wins Online"
        case '7': return "Cricket Hatrick – Match & Win | Scratch Card Game"
        case '11': return "Play Pet Race Scratch Card | Quick Prizes"
        case '8': return "Valentines Day – Top Scratch Card for Fast Wins"
        case '9': return "Charity Online Scratch Card – Try Your Luck"
        case '12': return "Happy Birthday Scratch Card – Instant Wins Online"
        case '10': return "Gold Bar – Match & Win | Scratch Card Game"
        case '13': return "Play Crorepati/Millionaire Scratch Card | Quick Prizes"
    }
};

const getDrawDescription = (drawtype, typeid) => {
    switch (drawtype) {
        case 'vs5luckyphnly': return 'Spin the reels on Lucky Phoenix with wild features, free spins, and high RTP. Smooth gameplay, fair odds, and exciting bonus rounds.';
        case 'vs15eyeofspart': return 'Try Eye of Spartacus, a fast-paced online slot packed with multipliers, wilds, and free spins. Play now and chase bigger payouts.';
        case 'vswaysmwss': return "Mahjong Wins Super Scatter delivers hot bonuses, crisp visuals, and rewarding features. Enjoy free spins and fair RTP on every spin.";
        case 'vs5luckyt1kly': return 'Play Lucky Tiger 1000—an immersive online slot with bonus rounds, scatter wins, and smooth mobile performance.';
        case 'vs20gtsofhades': return 'Experience Gates of Hades: wild reels, scatter wins, and generous free spins. Spin now for thrilling slot action.';
        case 'vswaysmjwl': return "Spin the reels on Mummy's Jewels with wild features, free spins, and high RTP. Smooth gameplay, fair odds, and exciting bonus rounds.";
        case 'vs20jjjack': return "Try Jumbo Safari, a fast-paced online slot packed with multipliers, wilds, and free spins. Play now and chase bigger payouts.";
        case 'vs10gbseries': return "Fiesta Fortune delivers hot bonuses, crisp visuals, and rewarding features. Enjoy free spins and fair RTP on every spin.";
        case 'vs5luckymly': return "Play Lucky Monkey—an immersive online slot with bonus rounds, scatter wins, and smooth mobile performance.";
        case 'vs25sleepdrag': return "Experience Sleeping Dragon: wild reels, scatter wins, and generous free spins. Spin now for thrilling slot action.";
        case '153': return "Spin the reels on MAGIC AQUARIUM with wild features, free spins, and high RTP. Smooth gameplay, fair odds, and exciting bonus rounds."
        case '161': return "Try FORTUNE PIRATES, a fast-paced online slot packed with multipliers, wilds, and free spins. Play now and chase bigger payouts."
        case '164': return "WILD DRAW delivers hot bonuses, crisp visuals, and rewarding features. Enjoy free spins and fair RTP on every spin."
        case '145': return "Play FRUITS CARNIVAL—an immersive online slot with bonus rounds, scatter wins, and smooth mobile performance."
        case '151': return "Experience GOLDEN QUEEN: wild reels, scatter wins, and generous free spins. Spin now for thrilling slot action."
        case '141': return "Spin the reels on LUCKY LATERN with wild features, free spins, and high RTP. Smooth gameplay, fair odds, and exciting bonus rounds."
        case '108': return "Try ZODIAC KINGDOM, a fast-paced online slot packed with multipliers, wilds, and free spins. Play now and chase bigger payouts."
        case '148': return "MAGIC BASKET delivers hot bonuses, crisp visuals, and rewarding features. Enjoy free spins and fair RTP on every spin."
        case '128': return "Play AFRICAN DIAMOND—an immersive online slot with bonus rounds, scatter wins, and smooth mobile performance."
        case '138': return "Experience MYSTERY ARK: wild reels, scatter wins, and generous free spins. Spin now for thrilling slot action."
        case 'vswayswildbrst': return "Spin the reels on Witch Heart Megaways with wild features, free spins, and high RTP. Smooth gameplay, fair odds, and exciting bonus rounds."
        case 'vswaysresurich': return "Try Resurrecting Riches, a fast-paced online slot packed with multipliers, wilds, and free spins. Play now and chase bigger payouts."
        case 'vs5jellyc': return "Jelly Candy delivers hot bonuses, crisp visuals, and rewarding features. Enjoy free spins and fair RTP on every spin."
        case 'vs20olympgold': return "Play Gates of Olympus Super Scatter—an immersive online slot with bonus rounds, scatter wins, and smooth mobile performance."
        case 'vs20fatbook': return "Experience Book of Monsters: wild reels, scatter wins, and generous free spins. Spin now for thrilling slot action."
        case 'vs5jokerjc': return "Spin the reels on Joker's Jewels Cash with wild features, free spins, and high RTP. Smooth gameplay, fair odds, and exciting bonus rounds."
        case 'vs9ridelightng': return "Try Ride The Lightning, a fast-paced online slot packed with multipliers, wilds, and free spins. Play now and chase bigger payouts."
        case 'vswaysmodfr': return "Ancient Island Megaways delivers hot bonuses, crisp visuals, and rewarding features. Enjoy free spins and fair RTP on every spin."
        case 'vs10fireice': return "Play Escape the Pyramid - Fire & Ice—an immersive online slot with bonus rounds, scatter wins, and smooth mobile performance."
        case 'vswaysaztec': return "Experience Aztec Gems Megaways: wild reels, scatter wins, and generous free spins. Spin now for thrilling slot action."

        case '1': return "Scratch, match, and win with Golden Match. Instant reveals, fair odds, and fast payouts. Play now for quick, exciting prizes."
        case '2': return "Feel the rush with Treasure Ticket—an instant-win scratch card with simple rules, crisp graphics, and real cash rewards."
        case '3': return "Lucky 1 brings quick thrills: scratch to reveal symbols, match to win, and claim payouts instantly. Start playing today."
        case '4': return "Try Super Scratch 10 for instant-win fun. Easy gameplay, transparent odds, and speedy payouts—scratch to uncover your prize."
        case '5': return "Get quick wins with Dream Match. Scratch to reveal matching symbols and enjoy fast, secure payouts and nonstop excitement."
        case '6': return "Scratch, match, and win with Christmas/Santa. Instant reveals, fair odds, and fast payouts. Play now for quick, exciting prizes."
        case '7': return "Feel the rush with Cricket Hatrick—an instant-win scratch card with simple rules, crisp graphics, and real cash rewards."
        case '11': return "Pet Race brings quick thrills: scratch to reveal symbols, match to win, and claim payouts instantly. Start playing today."
        case '8': return "Try Valentines Day for instant-win fun. Easy gameplay, transparent odds, and speedy payouts—scratch to uncover your prize."
        case '9': return "Get quick wins with Charity. Scratch to reveal matching symbols and enjoy fast, secure payouts and nonstop excitement."
        case '12': return "Get quick wins with Charity. Scratch to reveal matching symbols and enjoy fast, secure payouts and nonstop excitement."
        case '10': return "Feel the rush with Gold Bar—an instant-win scratch card with simple rules, crisp graphics, and real cash rewards."
        case '13': return "Crorepati/Millionaire brings quick thrills: scratch to reveal symbols, match to win, and claim payouts instantly. Start playing today."
    }
};


const ReturnKeyword = (drawtype, typeid) => {
    switch (drawtype) {
        case "vs5luckyphnly": return "Lucky Phoenix slot";
        case "vs15eyeofspart": return "Eye of Spartacus slot";
        case "vswaysmwss": return "Mahjong Wins Super Scatter slot";
        case "vs5luckyt1kly": return "Lucky Tiger 1000 slot";
        case "vs20gtsofhades": return "Gates of Hades slot";
        case "vswaysmjwl": return "Mummy's Jewels slot";
        case "vs20jjjack": return "Jumbo Safari slot";
        case "vs10gbseries": return "Fiesta Fortune slot";
        case "vs5luckymly": return "Lucky Monkey slot";
        case "vs25sleepdrag": return "Sleeping Dragon slot";
        case "153": return "MAGIC AQUARIUM slot";
        case "161": return "FORTUNE PIRATES slot";
        case "164": return "WILD DRAW slot";
        case "145": return "FRUITS CARNIVAL slot";
        case "151": return "GOLDEN QUEEN slot";
        case "141": return "LUCKY LATERN slot";
        case "108": return "ZODIAC KINGDOM slot";
        case "148": return "MAGIC BASKET slot";
        case "128": return "AFRICAN DIAMOND slot";
        case "138": return "MYSTERY ARK slot";
        case "vswayswildbrst": return "Witch Heart Megaways slot";
        case "vswaysresurich": return "Resurrecting Riches slot";
        case "vs5jellyc": return "Jelly Candy slot";
        case "vs20olympgold": return "Gates of Olympus Super Scatter slot";
        case "vs20fatbook": return "Book of Monsters slot";
        case "vs5jokerjc": return "Joker's Jewels Cash slot";
        case "vs9ridelightng": return "Ride The Lightning slot";
        case "vswaysmodfr": return "Ancient Island Megaways slot";
        case "vs10fireice": return "Escape the Pyramid - Fire & Ice slot";
        case "vswaysaztec": return "Aztec Gems Megaways slot";

        case '1': return "Golden Match scratch card"
        case '2': return "Treasure Ticket scratch card"
        case '3': return "Lucky 1 scratch card"
        case '4': return "Super Scratch 10 scratch card"
        case '5': return "Dream Match scratch card"
        case '6': return "Christmas/Santa scratch card"
        case '7': return "Cricket Hatrick scratch card"
        case '11': return "Pet Race scratch card"
        case '8': return "Valentines Day scratch card"
        case '9': return "Charity scratch card"
        case '12': return "Happy Birthday scratch card"
        case '10': return "Gold Bar scratch card"
        case '13': return "Crorepati/Millionaire scratch card"
    }

}



function OnlineSlotHelmetOthers({ drawType, typeid }) {
    console.log(typeid)
    let dd = [
        helmetJsonLdProp({
            "@context": "http://www.schema.org",
            "@graph": [
                {
                    "@type": "BreadcrumbList",
                    // "@id": "https://gulfticket.com/#breadcrumb",
                    itemListElement: [{ "@type": "ListItem", "position": 1, "name": "Draws" }]
                },
                {
                    "@type": "WebSite",
                    name: "Gulf Ticket ",
                    alternateName: "Gulf Ticket India",
                    url: process.env.REACT_APP_DESKTOP_URL
                }]
        })
    ]
    return (
        <div>
            <Helmet script={dd}>
                <title>{getDrawTitle(drawType, typeid)}</title>
                <meta name="description" content={getDrawDescription(drawType, typeid)} />
                <meta name="keywords" content={ReturnKeyword(drawType, typeid)} />
                <meta property="og:title" content={getDrawTitle(drawType, typeid)} />
                {/* <meta property="og:image" content={getDrawImage(drawType, typeid)} /> */}
                <meta property="og:site_name" content="Gulf Ticket" />
                <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                <meta property="og:description" content={getDrawDescription(drawType, typeid)} />
                <meta property="og:type" content="website" />
            </Helmet>
        </div>
    );
}

export default OnlineSlotHelmetOthers;
